module.exports = __webpack_public_path__ + "static/media/Sabrina J.94f750ca.jpeg";